// src/services/AuthService.tsx

import React, {
  ReactElement,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { useHistory } from "react-router";

interface UserType {
  id: string;
  name: string;
  email: string;
}

interface AuthContextType {
  currentUser: UserType | null;
  logout: () => void;
}

const AuthContext = React.createContext<AuthContextType>({
  currentUser: null,
  logout: () => {},
});

export function useAuth() {
  return useContext(AuthContext);
}

export default function AuthService({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState<UserType | null>(null);
  const history = useHistory();

  useEffect(() => {
    const timer = setTimeout(() => {
      const stored = localStorage.getItem("user");
      if (stored) {
        try {
          setCurrentUser(JSON.parse(stored));
        } catch {
          console.warn("Could not parse `user` from localStorage");
          localStorage.removeItem("user");
        history.replace("/login");
      }
      } else {
        history.replace("/login");
    }
      setLoading(false);
    }, 300);

    return () => clearTimeout(timer);
  }, [history]);

  const logout = () => {
    localStorage.removeItem("user");
    history.replace("/login");
  };

  return (
    <AuthContext.Provider value={{ currentUser, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

